import axios from 'axios'

export const getMapLayers = async () => {
  const layers = await axios.get(`/portal/layers/api/apps/layers?id=9b2aeab0-0798-4211-820e-6cc160768e27`)
  return layers.data
}
